import { Section, SectionIntro } from "@frontend/components/site/section";
import type { LegalSection } from "@frontend/components/site/legal-data";

export function LegalDoc({
  eyebrow,
  title,
  updated,
  intro,
  sections,
}: {
  eyebrow: string;
  title: string;
  updated: string;
  intro: string;
  sections: LegalSection[];
}) {
  return (
    <Section>
      <SectionIntro eyebrow={eyebrow} title={title} body={intro} />
      <p className="mt-3 text-sm text-ink-subtle">Last updated {updated}</p>

      <div className="mt-12 max-w-2xl space-y-10">
        {sections.map((section) => (
          <section key={section.title}>
            <h3 className="text-lg font-semibold tracking-tight text-ink">{section.title}</h3>
            <div className="mt-3 space-y-3 text-sm leading-relaxed text-ink-muted">
              {section.paragraphs.map((p, i) => (
                <p key={`${section.title}-p-${i}`}>{p}</p>
              ))}
              {section.bullets?.length ? (
                <ul className="list-disc space-y-2 pl-5">
                  {section.bullets.map((item, i) => (
                    <li key={`${section.title}-b-${i}`}>{item}</li>
                  ))}
                </ul>
              ) : null}
            </div>
          </section>
        ))}
      </div>
    </Section>
  );
}
